type ExtractLocation = Pick<Location, 'search'>;

// Extract redirect uri from location or dom.
export function extractFrom(location?: ExtractLocation | undefined): string {
  let stringParams = new URLSearchParams(location?.search);
  if (!location) {
    stringParams = new URLSearchParams(document.location.search);
  }
  const from = stringParams.get('from');
  return from || '';
}
type RedirectLocation = Pick<Location, 'pathname' | 'search'>;

// Return search params with redirect uri from location or dom.
export function setFrom(
  from?: string | undefined,
  location?: RedirectLocation | undefined,
): URLSearchParams {
  const newParams = new URLSearchParams();
  if (from) {
    newParams.set('from', from);
    return newParams;
  }

  if (location) {
    newParams.set('from', location.pathname + location.search);
    return newParams;
  }

  newParams.set('from', document.location.pathname + document.location.search);

  return newParams;
}
